<template>
  <VSelect
    :value="selected"
    :items="list"
    v-bind="$attrs"
    :label="$t('headers.os')"
    :hint="$t('form.os_display')"
    item-value="uid"
    @input="e => $emit('input', e)"
  >
    <template
      slot="selection"
      slot-scope="{ item: { platform, version }}"
    >
      <VChip>{{ platform }} {{ version }}</VChip>
    </template>
    <template
      slot="item"
      slot-scope="{ item: { platform, version }}"
    >
      {{ platform }} {{ version }}
    </template>
  </VSelect>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Os',
  inheritAttrs: false,
  model: {
    prop: 'selected',
  },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    devices: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('dictionary', ['os']),
    list() {
      return (this.os || [])
        .filter(({ type }) => this.devices.includes(type))
        .sort();
    },
  },
  created() {
    this.loadOs();
  },
  methods: {
    ...mapActions('dictionary', ['loadOs']),
  },
};
</script>
